export const selectHubs = state => state.get('hubs') || []
